export enum Role {
    ADMIN,
    MAYOR_TREASURER,
    CENTRAL_READER,
    FINANCIAL_MANAGER_ADMINISTRATOR,
    CENTRAL_EDITOR,
    SECRETARY_ASSISTANT,
    AGENT_RECENSEUR,
    PROPERTIES_EDITOR,
    PROPERTIES_LECTEUR,
    FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR,
    FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_EDITOR,
    FINANCIAL_EDITOR,
    MAYOR_TREASURER_AND_PROPERTIES_LECTEUR
  }
